module.exports = __webpack_public_path__ + "media/paliwa/on@2x-5f650854.png";